/*istanbul ignore next*/'use strict';

var Directive = require('../directive');

module.exports = new Directive({
  level: Directive.LP,
  final: true
});


// WEBPACK FOOTER //
// ./~/_mokit@3.1.3@mokit/lib/template/directives/prevent.js